import { useDispatch, useSelector } from 'react-redux';
import './css/app.css';
import './css/main.css';
import './css/common.css';
import './css/payment.css';
import './css/mobile.css';
import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { LoadingModal, MessageModal } from './component/modal/modal';

/** 카카오(다음) 우편번호 스크립트 로더 */
function loadDaumPostcode() {
    const SCRIPT_ID = 'daum-postcode-script';
    return new Promise((resolve, reject) => {
        if (window.daum?.Postcode) return resolve(true);
        if (document.getElementById(SCRIPT_ID)) {
            const check = setInterval(() => {
                if (window.daum?.Postcode) {
                    clearInterval(check);
                    resolve(true);
                }
            }, 50);
            setTimeout(() => {
                clearInterval(check);
                if (window.daum?.Postcode) resolve(true);
                else reject(new Error('Daum Postcode load timeout'));
            }, 5000);
            return;
        }
        const s = document.createElement('script');
        s.id = SCRIPT_ID;
        s.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
        s.async = true;
        s.onload = () => resolve(true);
        s.onerror = () => reject(new Error('Daum Postcode script failed'));
        document.head.appendChild(s);
    });
}

function UrlPayment() {
    const dispatch = useDispatch();
    const hostLogoImg = useSelector((state) => state.hostLogoImg.value);

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState({ msg: "" });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [listData, setListData] = useState([]);
    const [dataParam, setDataParam] = useState("");

    // ------- UrlDetail에서 넘어온 값 수신 -------
    const { state: passed } = useLocation(); // { product, quantity, unitPrice, amount }

    // 폼 데이터(자동 채움)
    const [formData, setFormData] = useState({
        MerchantName: "",
        GoodsName: "",
        GoodsCode: "",
        Amt: "",              // 숫자만 (총액)

        BuyerName: "",
        BuyerAddr: "",        // 서버 전송용(아래 Base/Extra/Detail 합쳐 자동세팅)
        BuyerEmail: "",
        BuyerHpTel: "",

        // 주소 세부
        Postcode: "",
        BaseAddr: "",         // 도로명/지번 기본주소
        ExtraAddr: "",        // 참고항목(동/건물명) - 자동 생성
        DetailAddr: "",       // 상세주소(사용자 입력)

        quantity: "1",
        PaymentMethod: "00",
        CashReceiptType: "0",
        CashReceiptInfo: "",
    });

    const [displayAmt, setDisplayAmt] = useState(""); // 콤마 포함 보여주기용
    const [phoneDisplayValue, setPhoneDisplayValue] = useState("");
    const [saveNextTime, setSaveNextTime] = useState(true);

    const navigate = useNavigate();
    const modalBodyRef = useRef(null);
    const fmt = (n) => (typeof n === "number" ? n.toLocaleString("ko-KR") : n);

    // ===== 주소검색 모달 관련 =====
    const [addrOpen, setAddrOpen] = useState(false);
    const addrLayerRef = useRef(null);
    const detailInputRef = useRef(null);

    useEffect(() => {
        if (addrOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = '';
        return () => { document.body.style.overflow = ''; };
    }, [addrOpen]);

    const openAddressSearch = async () => {
        try {
            await loadDaumPostcode();
            setAddrOpen(true);
            setTimeout(() => {
                const bodyEl = modalBodyRef.current;
                const wrapEl = addrLayerRef.current;
                if (!bodyEl || !wrapEl) return;

                // 바디 높이에 래퍼 높이를 맞춰주면 내부가 자연스럽게 스크롤됨
                const applyHeight = () => {
                    wrapEl.style.height = `${bodyEl.clientHeight}px`;
                };
                applyHeight();

                wrapEl.innerHTML = "";
                new window.daum.Postcode({
                    oncomplete: (data) => {
                        // ... (기존 oncomplete 그대로)
                    },
                    onresize: () => {
                        // iOS Safari 대응: 바디 높이에 계속 맞춰줌
                        applyHeight();
                    },
                    width: '100%',
                    height: '100%',
                    maxSuggestItems: 5
                }).embed(wrapEl);
            }, 0);
        } catch (e) {
            console.error(e);
            setMessage({ msg: "주소 검색 스크립트 로딩에 실패했습니다." });
        }
    };

    // 초기 진입 세팅
    useEffect(() => {
        dispatch(change_Current_Location("URL상품결제"));
        dispatch(changeHeaderTitle({ mainTitle: "URL상품결제", subTitle: "" }));
        const t = setTimeout(() => setLoading(false), 300);
        return () => clearTimeout(t);
    }, [dispatch]);

    // UrlDetail state → 자동 채움
    const unit = passed?.unitPrice ?? 0;
    const qtyFromState = passed?.quantity ?? 1;
    const totalFromState = passed?.amount ?? unit * qtyFromState;
    const prod = passed?.product || {};
    const prodImg = prod?.heroImages?.[0] || ""; // ✅ 썸네일
    const originalUnit = prod?.listPrice ?? unit;
    const showOriginal = Number(originalUnit) > Number(unit);

    useEffect(() => {
        if (!passed) return;
        setFormData((prev) => ({
            ...prev,
            MerchantName: prod.brand || prev.MerchantName,   // 가맹점=브랜드 기준
            GoodsName: prod.title || prev.GoodsName,
            GoodsCode: prod.modelName || prev.GoodsCode,
            quantity: String(qtyFromState),
            Amt: String(totalFromState),
        }));
        setDisplayAmt(fmt(totalFromState));
    }, [passed]); // eslint-disable-line

    // (옵션) URL 쿼리로 불러온 데이터도 지원 (state 없을 때만)
    useEffect(() => {
        if (passed) return;
        const params = new URLSearchParams(window.location.search);
        const value = params.get("data") || "";
        setDataParam(value);
        if (!value) return;
        (async () => {
            try {
                const res = await axios.get(
                    process.env.REACT_APP_API + "/api/url-pay",
                    { withCredentials: true, params: { data: value } }
                );
                const tmp = res?.data;
                if (tmp?.code < 2000) {
                    const d = tmp?.data ?? {};
                    setListData(d);
                    const priceNum = parseInt(String(d.price).replace(/\D/g, ""), 10) || 0;
                    const qty = 1;
                    const amount = priceNum * qty;
                    setFormData((prev) => ({
                        ...prev,
                        MerchantName: d?.co_nm ?? "",
                        GoodsName: d?.product_name ?? "",
                        GoodsCode: d?.product_code ?? "",
                        quantity: String(qty),
                        Amt: String(amount),
                    }));
                    setDisplayAmt(fmt(amount));
                } else if (tmp?.code === 9999) {
                    navigate("/");
                }
            } catch (e) {
                console.error(e);
                navigate("/");
            }
        })();
    }, [passed, navigate]);

    // 입력 핸들러들
    const handlePhoneChange = (e) => {
        let numeric = e.target.value.replace(/\D/g, "").slice(0, 11);
        const parts =
            numeric.length < 4
                ? [numeric]
                : numeric.length < 8
                    ? [numeric.slice(0, 3), numeric.slice(3)]
                    : [numeric.slice(0, 3), numeric.slice(3, 7), numeric.slice(7)];
        const displayVal = parts.join("-");
        setPhoneDisplayValue(displayVal);
        setFormData((prev) => ({ ...prev, BuyerHpTel: numeric }));
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Base/Extra/Detail → BuyerAddr 자동 결합
    useEffect(() => {
        const combined = [formData.BaseAddr, formData.ExtraAddr, formData.DetailAddr]
            .filter(Boolean)
            .join(' ')
            .trim();
        if (combined !== formData.BuyerAddr) {
            setFormData((prev) => ({ ...prev, BuyerAddr: combined }));
        }
    }, [formData.BaseAddr, formData.ExtraAddr, formData.DetailAddr]); // eslint-disable-line

    // 필수값 체크(비어있으면 버튼 비활성화)
    const requiredFilled =
        (formData.BuyerName || "").trim() !== "" &&
        (formData.BaseAddr || "").trim() !== "" &&    // 주소는 기본주소 기준
        (formData.BuyerEmail || "").trim() !== "" &&
        (formData.Postcode || "").trim() !== "" &&
        String(formData.BuyerHpTel || "").trim() !== "";

    const isDisabled = isSubmitting || !requiredFilled;

    // 결제 요청
    const onSubmitPayment = async () => {
        navigate('/urlComplete')

        // if (isDisabled) return;
        // setIsSubmitting(true);
        // setLoading(true);
        // try {
        //     const response = await axios.post(
        //         process.env.REACT_APP_API + "/api/url-pay",
        //         {
        //             data: dataParam,
        //             userAddress: formData.BuyerAddr,            // ✅ 결합된 전체 주소 전송
        //             ordNm: formData.BuyerName,
        //             email: formData.BuyerEmail,
        //             quantity: formData.quantity,
        //             tel: formData.BuyerHpTel,
        //             cashReceipt: formData.CashReceiptType,
        //             cashReceiptInfo: formData.CashReceiptInfo,
        //             saveNextTime,
        //             product: passed?.product,
        //             unitPrice: unit,
        //             amount: Number(formData.Amt || 0),
        //             postcode: formData.Postcode,                // (옵션) 우편번호 별도 전송
        //             baseAddr: formData.BaseAddr,                // (옵션) 기본주소 별도 전송
        //             detailAddr: formData.DetailAddr,            // (옵션) 상세주소 별도 전송
        //         },
        //         {}
        //     );
        //     const tmp = response?.data;
        //     console.log(tmp)
        //     navigate('/urlUserHistory')
        //     // if (tmp?.code < 2000) {
        //     //     // onSubmitPaymentModal(tmp?.data?.header, tmp?.data?.body)

        //     //     setLoading(false);
        //     //     setIsSubmitting(false);
        //     //     setMessage({ msg: "결제 요청 완료 (데모)" });
        //     // } else {
        //     //     setLoading(false);
        //     //     setIsSubmitting(false);
        //     //     setMessage({ msg: "결제실패" });
        //     // }
        // } catch (error) {
        //     console.error(error);
        //     setLoading(false);
        //     setIsSubmitting(false);
        //     const apiMsg = error?.response?.data?.msg || error?.message;
        //     setMessage({ msg: apiMsg ? `오류: ${apiMsg}` : "결제 요청 중 오류가 발생했습니다." });
        // }
    };

    const onSubmitPaymentModal = async (header, body) => {
        // 모바일 판별
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        // ✅ 1. 클릭 이벤트 콜스택에서 즉시 팝업 생성
        let newWindow;
        if (isMobile) {
            newWindow = window.open(
                'about:blank', // 사파리에서 안전하게 팝업 유지
                '_blank',
                `width=${window.innerWidth},height=${window.innerHeight},left=0,top=0`
            );
        } else {
            const width = 500;
            const height = 700;
            const left = window.screenX + (window.outerWidth - width) / 2;
            const top = window.screenY + (window.outerHeight - height) / 2;

            newWindow = window.open(
                'about:blank',
                '_blank',
                `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes`
            );
        }

        // ✅ 2. 팝업 차단 여부 체크
        const popupBlocked = !newWindow || typeof newWindow.closed === 'undefined';
        if (popupBlocked) {
            alert("사파리가 결제 팝업을 차단했습니다.\nSafari 설정 > 팝업 차단 해제를 해주시거나\n'결제창 열기' 버튼을 다시 눌러주세요.");
            return;
        }

        // ✅ 3. 팝업에 로딩 문구 표시 (UX 개선)
        newWindow.document.write('<p style="font:16px/1.4 -apple-system">결제창을 준비 중입니다...</p>');
        newWindow.document.close();

        // ✅ 4. 팝업 닫힘 감지
        const popupCheckInterval = setInterval(() => {
            if (newWindow.closed) {
                clearInterval(popupCheckInterval);
                console.log("팝업이 닫혔습니다.");
                setMessage({ mes: "팝업 닫힘" })
                onSubmitPaymentCheck(header, body);
            }
        }, 500);

        try {
            const response = await axios.post(
                "https://jh.winglobalpay.com/api/payment/request",
                JSON.stringify(body),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: header?.Authorization ?? "",
                    },
                }
            );

            const tmp = response?.data;
            console.log(tmp);

            // 4. 성공 시 팝업 안에서 URL 이동
            if (tmp?.success && tmp?.paymentUrl) {
                newWindow.location.href = tmp.paymentUrl;
            } else {
                newWindow.close();
                setLoading(false);
                setIsSubmitting(false);
                setMessage({ msg: "결제실패" });
            }
        } catch (error) {
            console.error(error);
            newWindow.close();
            const apiMsg = error?.response?.data?.msg || error?.message;
            setMessage({ msg: apiMsg ? `오류: ${apiMsg}` : "결제 요청 중 오류가 발생했습니다." });
        }
    };

    const onSubmitPaymentCheck = async (header, body) => {
        try {
            const response = await axios.get(
                "https://jh.winglobalpay.com" + `/api/payment/status/${body?.tid ?? ""}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: header?.Authorization ?? "",
                    },
                }
            );

            let tmp = response?.data;
            console.log(tmp)
            if (tmp?.success) {
                // onSubmitPaymentSave()
                navigate("/urlComplete", {
                    state: {
                        receipt: tmp,
                        listData, // 현재 컴포넌트의 리스트 상태
                    },
                    replace: false,
                });
            } else {
                setLoading(false);
                setIsSubmitting(false);
                setMessage({ msg: "결제실패" });
            }
        } catch (error) {
            console.error(error);

            setLoading(false);
            setIsSubmitting(false);
            // 서버가 에러 메시지를 내려주면 노출
            const apiMsg = error?.response?.data?.msg || error?.message;
            setMessage({ msg: apiMsg ? `오류: ${apiMsg}` : "결제 요청 중 오류가 발생했습니다." });
        } finally {
            setLoading(false);
            setIsSubmitting(false);
        }
    };

    const onSubmitPaymentSave = async () => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/url-pay/save",
                {

                }, { withCredentials: true }
            );

            let tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {

            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            {loading ? <LoadingModal /> : null}
            <MessageModal message={message} />

            <div style={{ minHeight: "100dvh", height: '100%', background: "#f3f5f7" }}>
                <div className="urlPayment-wrap">
                    {/* 배송지 */}
                    <section className="urlPayment-section">
                        <h2 className="urlPayment-title">배송지</h2>
                        <div className="urlPayment-card">
                            <div className="urlPayment-row">
                                <label className="urlPayment-label">구매자명</label>
                                <input
                                    name="BuyerName"
                                    className="urlPayment-input"
                                    placeholder="이름 입력"
                                    value={formData.BuyerName}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="urlPayment-row">
                                <label className="urlPayment-label">연락처</label>
                                <input
                                    name="BuyerHpTel_display"
                                    className="urlPayment-input"
                                    placeholder="010-0000-0000"
                                    value={phoneDisplayValue}
                                    onChange={handlePhoneChange}
                                />
                            </div>

                            {/* 주소 - 우편번호 + 검색 버튼 */}
                            <div className="urlPayment-row">
                                <label className="urlPayment-label">주소</label>
                                <div style={{ display: 'flex', gap: 8 }}>
                                    <input
                                        name="Postcode"
                                        className="urlPayment-input"
                                        placeholder="우편번호"
                                        value={formData.Postcode}
                                        onChange={handleChange}
                                        style={{ width: "100px" }}
                                    />
                                    <button
                                        type="button"
                                        className="urlPayment-btn"
                                        onClick={openAddressSearch}
                                        style={{
                                            flex: '0 0 auto',
                                            padding: '0px 10px',
                                            borderRadius: 8,
                                            border: '1px solid #222',
                                            background: '#111',
                                            color: '#fff',
                                            cursor: 'pointer',
                                            minWidth: 72
                                        }}
                                    >
                                        주소 검색
                                    </button>
                                </div>
                            </div>

                            {/* 주소 - 기본주소(참고항목 포함, 읽기전용) */}
                            <div className="urlPayment-row">
                                <label className="urlPayment-label"></label>
                                <input
                                    name="BaseAddr"
                                    className="urlPayment-input"
                                    placeholder="도로명/지번 주소"
                                    value={formData.BaseAddr + (formData.ExtraAddr ? ` ${formData.ExtraAddr}` : '')}
                                    onChange={(e) => {
                                        // 직접 수정 허용: ExtraAddr 분리는 유지
                                        setFormData((prev) => ({ ...prev, BaseAddr: e.target.value, ExtraAddr: "" }));
                                    }}
                                />
                            </div>

                            {/* 주소 - 상세주소(입력) */}
                            <div className="urlPayment-row">
                                <label className="urlPayment-label"></label>
                                <input
                                    ref={detailInputRef}
                                    name="DetailAddr"
                                    className="urlPayment-input"
                                    placeholder="상세주소 입력"
                                    value={formData.DetailAddr}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </section>

                    {/* 주문상품 */}
                    <section className="urlPayment-section">
                        <h2 className="urlPayment-title">주문상품</h2>

                        <div className="urlPayment-card card1">
                            <div className="urlPayment-orderHead">
                                <div className="urlPayment-store">
                                    {formData.MerchantName || "가맹점"}
                                </div>
                                <div className="urlPayment-shipFee">배송비 무료</div>
                            </div>

                            <div className="urlPayment-orderBody">
                                <div className="urlPayment-thumb">
                                    {prodImg ? <img src={prodImg} alt="" className="urlPayment-thumbImg" /> : null}
                                </div>
                                <div className="urlPayment-info">
                                    <div className="urlPayment-prod">{formData.GoodsName || "상품명"}</div>

                                    {/* 옵션/수량 + 단가 영역 */}
                                    <div className="urlPayment-itemBar">
                                        <div className="urlPayment-itemLeft">수량&nbsp;:&nbsp;{qtyFromState}개</div>
                                        <div className="urlPayment-itemRight">
                                            {showOriginal && (
                                                <span className="urlPayment-priceOld">{fmt(Number(originalUnit) * Number(qtyFromState))}</span>
                                            )}
                                            <span className="urlPayment-priceNow">{fmt(Number(unit) * Number(qtyFromState))}원</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 총 주문금액(카드 내부에 이어붙임) */}
                            <div className="urlPayment-totalInline">
                                <span className="urlPayment-totalLabel">총 주문금액</span>
                                <b className="urlPayment-totalValue">{displayAmt || "0"}원</b>
                            </div>
                        </div>
                    </section>

                    {/* 결제수단 */}
                    <section className="urlPayment-section">
                        <h2 className="urlPayment-title">결제수단</h2>
                        <div className="urlPayment-card">
                            <div className="urlPayment-row">
                                <label className="urlPayment-label">결제수단</label>
                                <select
                                    name="PaymentMethod"
                                    className="urlPayment-select"
                                    value={formData.PaymentMethod}
                                    onChange={handleChange}
                                >
                                    <option value="00">신용카드</option>
                                </select>
                            </div>

                            <div className="urlPayment-row">
                                <label className="urlPayment-label">이메일</label>
                                <input
                                    name="BuyerEmail"
                                    className="urlPayment-input"
                                    placeholder="email@example.com"
                                    value={formData.BuyerEmail}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </section>

                    {/* 현금영수증 */}
                    <section className="urlPayment-section">
                        <h2 className="urlPayment-title">현금영수증</h2>
                        <div className="urlPayment-card">
                            <div className="urlPayment-row">
                                <label className="urlPayment-label">발급 여부</label>
                                <select
                                    name="CashReceiptType"
                                    className="urlPayment-select"
                                    value={formData.CashReceiptType}
                                    onChange={handleChange}
                                >
                                    <option value="0">발급안함</option>
                                    <option value="1">소득공제용 발급</option>
                                </select>
                            </div>

                            {formData.CashReceiptType === "1" && (
                                <div className="urlPayment-row">
                                    <label className="urlPayment-label">발행정보</label>
                                    <input
                                        name="CashReceiptInfo"
                                        className="urlPayment-input"
                                        placeholder="전화번호/사업자번호"
                                        value={formData.CashReceiptInfo}
                                        onChange={handleChange}
                                    />
                                </div>
                            )}
                        </div>
                    </section>

                    {/* 하단 버튼 공간 확보 */}
                    <div className="urlPayment-bottomPad" />
                </div>

                {/* 하단 고정 버튼: “{금액}원 결제하기” */}
                <div className="urlPayment-buybar">
                    <button
                        className="urlPayment-buyBtn"
                        onClick={onSubmitPayment}
                        disabled={isDisabled}
                    >
                        {isSubmitting ? "결제중..." : `${displayAmt || "0"}원 결제하기`}
                    </button>
                </div>
            </div>

            {/* ===== 주소검색 모달 ===== */}
            {/* ===== 주소검색 모달 ===== */}
            {addrOpen && (
                <div
                    onClick={() => setAddrOpen(false)}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(0,0,0,0.45)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        padding: 16,
                        overflow: 'hidden', // 바깥 스크롤 잠금
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            width: 'min(720px, 100%)',
                            maxHeight: '90vh',
                            background: '#fff',
                            borderRadius: 12,
                            boxShadow: '0 12px 40px rgba(0,0,0,0.25)',
                            display: 'flex',
                            flexDirection: 'column',
                            overflow: 'hidden',
                        }}
                    >
                        {/* 헤더(닫기 버튼 포함) */}
                        <div style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            padding: '10px 12px', borderBottom: '1px solid #eee', position: 'sticky', top: 0, background: '#fff', zIndex: 1
                        }}>
                            <b>주소 검색</b>
                            <button
                                onClick={() => setAddrOpen(false)}
                                style={{ border: 'none', background: '#000', color: '#fff', borderRadius: 8, padding: '6px 10px', cursor: 'pointer' }}
                            >
                                닫기
                            </button>
                        </div>

                        {/* 스크롤되는 바디 */}
                        <div
                            ref={modalBodyRef}
                            style={{
                                flex: '1 1 auto',
                                overflowY: 'auto',
                                WebkitOverflowScrolling: 'touch',
                                overscrollBehavior: 'contain',
                            }}
                        >
                            {/* 우편번호 컴포넌트가 박히는 래퍼 */}
                            <div ref={addrLayerRef} style={{ width: '100%', height: '100%', minHeight: 420 }} />
                        </div>
                    </div>
                </div>
            )}

        </>
    );
}

export default UrlPayment;
